import React from 'react';
import { Alert, AlertTitle, Button, Box, IconButton, Collapse } from '@mui/material';
import { Close as CloseIcon, Add as AddIcon, Warning as WarningIcon, Error as ErrorIcon, Info as InfoIcon } from '@mui/icons-material';
import { useCreditWarning } from '../../contexts/CreditWarningContext';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../constants/routes';

const CreditWarningInPlayer = () => {
  const { warnings, showWarning, dismissWarning } = useCreditWarning();
  const navigate = useNavigate();

  const getSeverity = (severity) => {
    switch (severity) {
      case 'error': return 'error';
      case 'warning': return 'warning';
      case 'info': return 'info';
      default: return 'warning';
    }
  };

  const getIcon = (severity) => {
    switch (severity) {
      case 'error': return <ErrorIcon />;
      case 'warning': return <WarningIcon />;
      case 'info': return <InfoIcon />;
      default: return <WarningIcon />;
    }
  };

  const handleAddCredit = () => {
    navigate(AppRoutes.ListenerPayments);
  };

  if (!showWarning || warnings.length === 0) {
    return null;
  }

  return (
    <Box sx={{ 
      position: 'absolute',
      top: -60, // Position above the music player
      left: 0,
      right: 0,
      zIndex: 1001,
      px: 2
    }}>
      {warnings.map((warning, index) => (
        <Collapse key={warning.type} in={true}>
          <Alert
            severity={getSeverity(warning.severity)}
            icon={getIcon(warning.severity)}
            action={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {warning.action === 'add_credit' && (
                  <Button
                    color="inherit"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleAddCredit}
                    sx={{ textTransform: 'none' }}
                  >
                    Add Credit
                  </Button>
                )}
                {warning.action === 'add_credit_urgent' && (
                  <Button
                    color="inherit"
                    size="small"
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleAddCredit}
                    sx={{ textTransform: 'none' }}
                  >
                    Add Credit Now
                  </Button>
                )}
                <IconButton
                  size="small"
                  onClick={() => dismissWarning(warning.type)}
                  color="inherit"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            }
            sx={{
              borderRadius: 1,
              '& .MuiAlert-message': {
                width: '100%'
              }
            }}
          >
            <AlertTitle>{warning.title}</AlertTitle>
            {warning.message}
          </Alert>
        </Collapse>
      ))}
    </Box>
  );
};

export default CreditWarningInPlayer;
